import React from 'react';

import Breadcrumb from '../../../breadcrumb';
import SearchForm from '../form';

import {
  StyledSection,
  StyledSectionInner,
  StyledFormWrapper,
  StyledTextBlock,
  StyledText
} from './styles';

const Header = () => {
  return (
    <StyledSection>
      <StyledSectionInner>
        <Breadcrumb name="Search" url="search" />

        <StyledTextBlock>
          <StyledText>Search Results</StyledText>
        </StyledTextBlock>

        <StyledFormWrapper>
          <SearchForm />
        </StyledFormWrapper>
      </StyledSectionInner>
    </StyledSection>
  );
};

export default Header;
